import {ApiService} from '../api';

const getExchangeRate = async (
  sourceCurrency: string,
  targetCurrency: string,
  measurementDateId: string,
  currencyDate?: string
): Promise<string> => {
  let closePrice = '1'; // Default value if sourceCurrency is the same as targetCurrency
  if (sourceCurrency !== targetCurrency) {
    // Implement the financials --> cap table currency conversion
    const currencies = `$${targetCurrency}${sourceCurrency}:`;
    const response = await ApiService.apiValuationGetExchangeRateRead(measurementDateId, currencies, currencyDate)
    
    if (response?.valid_exchange_data) {
      closePrice = response?.exchange_rate?.close_price?.value;
    }
  }

  return closePrice;
};

export default getExchangeRate;